import {
  Button,
  Col,
  Form,
  Popconfirm,
  Row,
  Table,
  TableProps,
  Typography,
} from "antd";
import { useEffect, useState } from "react";
import { DeleteCategory, GetDesignationCategories } from "../../../API/api";
import AdminLayout from "../../../component/AdminLayout";

import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { SorterResult } from "antd/es/table/interface";
import SearchBar from "../../../component/Search";
import { enqueueSnackbar } from "notistack";
import { customSortDirections } from "../../../Utils/utils";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { useUserRole } from "../../../API/RoleContext";
import AddEditNewCategory from "../components/AddEditNewCategory";
import DesignationList from "../components/DesignationsList";
import "./Designation.scss";

interface CategoryItem {
  categoryId: number;
  categoryName: string;
  designationCount: number;
  key: number;
}

const Designation = () => {
  const userRole = useUserRole();
  const [isAdd, setIsAdd] = useState<boolean>(false);
  const [openDesignationListPopup, setOpenDesignationListPopup] =
    useState<boolean>(false);
  const [categoryId, setCategoryId] = useState<number>(0);
  const [editDetails, setEditDetails] = useState({});

  const [sortedInfo, setSortedInfo] = useState<SorterResult<CategoryItem>>({});
  const [openAddNewCategoryPopup, setOpenAddNewCategoryPopup] = useState(false);
  const [designationCategory, setDesignationCategoryList] = useState<
    CategoryItem[]
  >([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [form] = Form.useForm();
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState<CategoryItem[]>([]);
  const [pagesize, setPageSize] = useState<number>(50);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getDesignationCategoryList();
  }, []);

  useEffect(() => {
    if (searchText) filterData(searchText);
  }, [designationCategory]);
  const getDesignationCategoryList = async () => {
    try {
      setIsLoading(true);
      const response = await GetDesignationCategories();
      const newData = response.data.map((category: any, index: number) => ({
        ...category,
        key: category.categoryId,
      }));
      setDesignationCategoryList(newData);
      setIsLoading(false);
    } catch (error: any) {
      enqueueSnackbar(error, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      setIsLoading(false);
    }
  };
  const edit = (record: Partial<CategoryItem> & { key: React.Key }) => {
    setIsAdd(false);
    setOpenAddNewCategoryPopup(true);
    setEditDetails(record);
  };
  const handleDelete = (rowData: any) => {
    setIsLoading(true);
    DeleteCategory(rowData)
      .then((response: any) => {
        enqueueSnackbar("Deleted Successfully", {
          variant: "success",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });

        setIsLoading(false);
        getDesignationCategoryList();
      })
      .catch((error: any) => {
        enqueueSnackbar(error.response.data.errors.Category[0], {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
        setIsLoading(false);
      });
  };
  const columns = [
    {
      title: "No",
      dataIndex: "id",
      key: "id",
      width: "10%",
      render: (text: any, record: any, index: number) =>
        (currentPage - 1) * pagesize + index + 1,
    },
    {
      title: "Category",
      dataIndex: "categoryName",
      key: "categoryName",
      width: "40%",
      sorter: (a: any, b: any) => a.categoryName.localeCompare(b.categoryName),
      sortOrder:
        sortedInfo.columnKey === "categoryName" ? sortedInfo.order : null,
      render: (text: string) => <div>{text}</div>,
    },
    {
      title: "Designation Count",
      dataIndex: "designationCount",
      key: "designationCount",
      width: "40%",

      render: (text: string, record: any) => (
        <Typography.Link onClick={() => getDesignations(record)}>
          {text}
        </Typography.Link>
      ),
    },
    ...(!userRole.includes("Manager") && !userRole.includes("CEO")
      ? [
          {
            title: "Action",
            dataIndex: "action",
            width: "20%",

            render: (_: any, record: any) => {
              return (
                <>
                  {" "}
                  <Typography.Link onClick={() => edit(record)}>
                    <EditOutlined />
                  </Typography.Link>
                  <Popconfirm
                    title="Do you want to delete the category?"
                    onConfirm={() => handleDelete(record.key)}
                  >
                    <Typography.Link className="delete-btn">
                      <DeleteOutlined />
                    </Typography.Link>
                  </Popconfirm>
                </>
              );
            },
          },
        ]
      : []),
  ];

  const getDesignations = (rowData: any) => {
    setCategoryId(rowData.categoryId);
    setOpenDesignationListPopup(true);
  };

  const handleChange: TableProps<CategoryItem>["onChange"] = (
    pagination,
    filters,
    sorter
  ) => {
    setSortedInfo(sorter as SorterResult<CategoryItem>);
    setCurrentPage(pagination.current || 1);
    setPageSize(pagination.pageSize ?? 50);
  };

  const handleSearch = (value: string) => {
    setCurrentPage(1);
    setSearchText(value);
    filterData(value);
  };
  const filterData = (searchText: string) => {
    if (!searchText) {
      setFilteredData([]);
    } else {
      const filtered = designationCategory.filter((item: any) =>
        item.categoryName.toLowerCase().includes(searchText.toLowerCase())
      );
      setFilteredData(filtered);
    }
  };

  const handleAddNewCategory = () => {
    setEditDetails([]);
    setIsAdd(true);
    setOpenAddNewCategoryPopup(true);
  };
  const handleCloseAddEdit = (isReload: boolean) => {
    if (isReload) getDesignationCategoryList();
    setOpenAddNewCategoryPopup(false);
  };
  const handleClosePopup = () => setOpenDesignationListPopup(false);
  return (
    <>
      <AdminLayout>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <div>
          <div className="employee-table-header ">
            <Row
              gutter={16}
              style={{ alignItems: "center", margin: "12px 16px 0 16px" }}
            >
              <Col className="gutter-row" lg={12} sm={24}>
                <h3 className="bottom-margin-mob" style={{ float: "left" }}>
                  Designation
                </h3>
              </Col>
              <Col
                className="gutter-row pm-search-flex"
                lg={{ span: 10, offset: 2 }}
                sm={24}
                xs={24}
                style={{ display: "flex" }}
              >
                <SearchBar
                  width={"100%"}
                  onSearch={handleSearch}
                  placeholder={"Search Category"}
                />
                {!userRole.includes("Manager") && !userRole.includes("CEO") && (
                  <Button
                    onClick={handleAddNewCategory}
                    type="primary"
                    style={{ marginLeft: 10 }}
                    size="small"
                  >
                    Add Category
                  </Button>
                )}
              </Col>
            </Row>
          </div>

          <Form form={form} component={false}>
            <Table
              sortDirections={customSortDirections}
              scroll={{ x: 1000, y: 450 }}
              className="status-list-admin"
              columns={columns}
              size="small"
              pagination={{
                current: currentPage,
                showSizeChanger: true,
                defaultPageSize: 50,
              }}
              onChange={handleChange}
              rowClassName="editable-row"
              dataSource={searchText ? filteredData : designationCategory}
            />
          </Form>
          {openAddNewCategoryPopup && (
            <AddEditNewCategory
              editDetails={editDetails}
              handleCloseAddEdit={handleCloseAddEdit}
              isAdd={isAdd}
            />
          )}
          {openDesignationListPopup && (
            <DesignationList
              handleClosePopup={handleClosePopup}
              categoryId={categoryId}
            />
          )}
        </div>
      </AdminLayout>
    </>
  );
};
export default Designation;
